import $ from "jquery";

function showSpinner() {
    $('#nav-loader-spinner').show();
}

function hideSpinner() {
    $('#nav-loader-spinner').hide();
}

export class AbconetApi {
    static post(url, data, signal, hideErrors) {
        showSpinner();
        return fetch(url,
                {
                    method: 'POST',
                    body: JSON.stringify(data),
                    signal: signal,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
            }).then(function (response) {
                hideSpinner();
                return response;
            })
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                if (response && response.type === "Error") {
                    if (response.message === "You need to be logged in to have access to this content.") {
                        $(document).trigger("LoginUpdated", { loggedIn: false });
                    }
                    
                    if (hideErrors !== true) {
                        $(document).trigger("AlertUpdated",
                            {
                                type: "danger",
                                message: response.message
                            });
                    }

                    throw Error(response.message);
                } else {
                    return response;
                }
            });
    }

    static get(url, signal) {
        showSpinner();
        return fetch(url,
                {
                    method: 'GET',
                    signal: signal,
                }).then(function (response) {
                return response;
            })
            .then(function (response) {
                hideSpinner();
                return response.json();
            })
            .then(function (response) {
                if (response && response.type === "Error") {
                    if (response.message === "You need to be logged in to have access to this content.") {
                        $(document).trigger("LoginUpdated", { loggedIn: false });
                    }
                    $(document).trigger("AlertUpdated", {
                        type: "danger",
                        message: response.message
                    });
                    throw Error(response.message);
                } else {
                    return response;
                }
            });
    }

    static delete(url) {
        showSpinner();
        return fetch(url,
            {
                method: 'DELETE'
            }).then(function (response) {
                hideSpinner();
                return response;
            })
            .then(function (response) {
                return response.json();
            })
            .then(function (response) {
                if (response && response.type === "Error") {
                    if (response.message === "You need to be logged in to have access to this content.") {
                        $(document).trigger("LoginUpdated", { loggedIn: false });
                    }
                    $(document).trigger("AlertUpdated", {
                        type: "danger",
                        message: response.message
                    });
                    throw Error(response.message);
                } else {
                    return response;
                }
            });;
    }
}